import type { ProfessionalTypeEnum } from '@gql/graphql';
import type { DetailListProps } from '@presentation/components';

export type DetailListProPracticalItemType =
  | 'employeeNumbers'
  | 'paymentMethods'
  | 'shop'
  | 'shopGroomer'
  | 'parking'
  | 'onlineAppointment'
  | 'selfDogWash'
  | 'graduated'
  | 'acceptsNewClients'
  | 'acceptedAnimals'
  | 'visitAtHome'
  | 'formations'
  | 'practicePlaces';

export interface DetailListProPracticalData {
  items: Partial<Record<DetailListProPracticalItemType, string>>;
}

export interface DetaiListProPracticalProps
  extends Omit<DetailListProps, 'items'>,
    DetailListProPracticalData {
  proType?: ProfessionalTypeEnum;
}
